import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { useArtistStory } from "@/api/hooks/useArtistStory";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";
import { ArtistStoryRichText } from "@/components/profile/ArtistStoryRichText";
import { WEBSITE_STORY_HOVER_TEXT } from "@/pages/profile/website-preview/storyPreviewHoverClasses";
import { cn } from "@/utils/cn";
import { User } from "lucide-react";

const ArtistPremiumStory = () => {
  const { storyHtml, hasStory } = useArtistStory();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();

  return (
    <div className="flex items-center max-sm:flex-col justify-around gap-10 my-28 w-screen">
      <div className="rounded-3xl relative w-[450px] max-sm:w-full h-[655px] overflow-hidden bg-[#2C2C2E] flex items-center justify-center">
        {profilePic ? (
          <OptimizedImage
            src={profilePic}
            fill
            unoptimized
            alt={displayName}
            className="object-cover object-center rounded-3xl"
          />
        ) : (
          <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
        )}
      </div>

      <div className="max-w-2xl space-y-2 max-sm:px-4">
        <h2 className="text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text">
          My Story
        </h2>

        {/* <p className="bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text text-2xl">
          TOM CRUISE
        </p> */}
        <div className="group max-w-full">
          <ArtistStoryRichText
            storyHtml={storyHtml}
            hasStory={hasStory}
            variant="split"
            className={cn(
              'max-w-lg max-h-[480px] overflow-auto custom-scroll py-4 pr-10 max-sm:pr-0',
              WEBSITE_STORY_HOVER_TEXT,
            )}
          />
        </div>
        <button className="bg-gradient-to-b from-[#EC2179] to-[#F16B2E] px-8 py-3 text-lg max-sm:text-sm rounded-xl">
          SEE PRICE & BOOK
        </button>
      </div>
    </div>
  );
};

export default ArtistPremiumStory;
